<template>
	<div>
		<q-card>
			<q-card-title>
				{{ title }}
			</q-card-title>
			<q-card-separator />
			<q-card-main>
				<div class="q-ma-sm">
					{{ description }}
				</div>
				<div class="q-ma-sm">
					{{ `${$t('stream_type')}: ${getLiveClassPlatformTypes(platform_type)}` }}
				</div>
				<div v-if="$q.platform.is.mobile" class="q-ma-sm text-body2">
					{{ $t('mobile_live_class_instructor_helper') }}
				</div>
				<div class="q-mt-md q-pa-md text-center">
					<q-btn
						color="primary"
						:disable="joinClassDisabled"
						@click="
							platform_type === 'jitsi'
								? (show_modal_class_room = true)
								: openMeeting()
						"
					>
						<q-icon left size="3em" name="fas fa-chalkboard" />
						<div class="q-pa-sm">{{ $t('start_live_class') }}</div>
					</q-btn>
				</div>
			</q-card-main>
		</q-card>

		<q-modal
			v-if="show_modal_class_room"
			v-model="show_modal_class_room"
			:content-css="{ minWidth: '100vw', minHeight: '100vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
			maximized
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="hideModalClassRoom()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ title }}
					</q-toolbar-title>
				</q-toolbar>

				<class-room
					v-if="show_modal_class_room"
					:room="room"
					:title="title"
					@hideModalClassRoom="hideModalClassRoom"
				/>
			</q-modal-layout>
		</q-modal>

		<q-dialog
			v-model="show_meet_dialog"
			stack-buttons
			prevent-close
			@cancel="show_meet_dialog = false"
			@hide="show_meet_dialog = false"
		>
			<span slot="title">{{ $t('window_blocked') }}</span>
			<span slot="message">
				{{ $t('browser_window_blocked_click') }}
				<a :href="meet_external_url" target="_blank" rel="noopener noreferrer">{{
					$t('here')
				}}</a>
				{{ $t('to_access_the_class') }}
			</span>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
// const { formatDate } = date

export default {
	name: 'AdminLiveClassTab',

	// id_presential and id_event will be received only for presential training live classes
	props: [
		'title',
		'description',
		'room',
		'platform_type',
		'embed',
		'date_class',
		'timezone',
		'status',
		'id_presential',
		'id_event',
	],

	data() {
		return {
			show_modal_class_room: false,
			show_meet_dialog: false,
			meet_external_url: null,
		}
	},

	components: {
		'class-room': () => import('components/admin/live_classe/ClassRoom'),
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			live_class_platform_types: 'registration_lists/live_class_platform_types',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		joinClassDisabled() {
			const dateNow = new Date()
			const diff = date.getDateDiff(dateNow, this.date_class, 'minutes')
			if (diff < -15 || diff >= 360) return true
			else return false
		},
	},

	methods: {
		hideModalClassRoom() {
			this.show_modal_class_room = false
		},

		getLiveClassPlatformTypes(platform) {
			if (this.live_class_platform_types && this.live_class_platform_types.length) {
				const platformType = this.live_class_platform_types.find(
					(type) => platform === type.slug
				)
				return platformType && platformType.label ? platformType.label : ''
			} else return ''
		},

		openMeeting() {
			this.meet_external_url = this.embed
			let meet = window.open(this.embed, '_blank')
			if (meet === null) {
				this.show_meet_dialog = true
			} else return
		},
	},

	beforeRouteUpdate(to, from, next) {
		this.id_live_class = to.params.id
		next()
	},

	created() {
		this.id_live_class = this.$route.params.id
	},
}
</script>

<style></style>
